;(() => {
  if (window.mainContactGorgiasKlaviyoBound) return

  window.mainContactGorgiasKlaviyoBound = true

  const SELECTORS = {
    section: '.main-contact',
    gorgiasIframe: '[data-gorgias-iframe-contact-form]',
    liveChatTrigger: '[data-live-chat-trigger]'
  }

  const GORGIAS_ORIGIN = 'https://contact.gorgias.help'
  const GORGIAS_FETCH_REQUEST = 'gorgias-fetch-request'
  const KLAVIYO_REVISION = '2026-04-15'
  const recentSubmissions = new Set()

  const openLiveChat = () => {
    if (!window.theme || !window.theme.liveChatEnabled) return

    if (window.theme.liveChatProvider === 'gorgias') {
      if (window.GorgiasChat && typeof window.GorgiasChat.open === 'function') {
        window.GorgiasChat.open()
      }

      return
    }

    if (typeof window.zE === 'function') {
      window.zE('messenger', 'open')
    }
  }

  const parseBody = (body) => {
    if (!body) return null
    if (typeof body === 'string') {
      try {
        return JSON.parse(body)
      } catch (error) {
        return null
      }
    }

    if (body instanceof FormData) {
      return Object.fromEntries(body.entries())
    }

    return typeof body === 'object' ? body : null
  }

  const getRequestBody = (fetchOptions = {}) => parseBody(fetchOptions.body)

  const getSectionFromMessageSource = (source) => {
    if (!source) return null

    const iframe = [...document.querySelectorAll(SELECTORS.gorgiasIframe)].find((frame) => frame.contentWindow === source)

    return iframe ? iframe.closest(SELECTORS.section) : null
  }

  const getContactFormUidFromUrl = (url = '') => {
    const match = url.match(/\/api\/contact-forms\/([^/?]+)/)

    return match ? decodeURIComponent(match[1]) : ''
  }

  const isGorgiasContactSubmit = (event, section) => {
    if (event.origin !== GORGIAS_ORIGIN || !section) return false
    if (!event.data || event.data.type !== GORGIAS_FETCH_REQUEST) return false

    const { url = '', fetchOptions = {} } = event.data
    const method = (fetchOptions.method || 'GET').toUpperCase()
    const formUid = getContactFormUidFromUrl(url)

    return method === 'POST' && formUid && formUid === section.dataset.gorgiasContactFormUid
  }

  const splitName = (fullName = '') => {
    const parts = fullName.trim().split(/\s+/).filter(Boolean)

    return {
      firstName: parts[0] || '',
      lastName: parts.slice(1).join(' ')
    }
  }

  const subscribeToKlaviyo = (section, submission) => {
    const publicKey = section.dataset.klaviyoPublicKey
    const subscriptionUrl = section.dataset.klaviyoSubscriptionUrl
    const listId = section.dataset.klaviyoListId
    const source = section.dataset.klaviyoSource || 'Contact Us Page'
    const email = submission.email

    if (!publicKey || !subscriptionUrl || !listId || !email) return

    const dedupeKey = [email, submission.subject, submission.message].join('|')
    if (recentSubmissions.has(dedupeKey)) return

    recentSubmissions.add(dedupeKey)
    window.setTimeout(() => recentSubmissions.delete(dedupeKey), 10000)

    const { firstName, lastName } = splitName(submission.full_name)
    const payload = {
      data: {
        type: 'subscription',
        attributes: {
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email,
                first_name: firstName,
                last_name: lastName,
                properties: {
                  ContactSource: source,
                  ContactSubject: submission.subject || '',
                  ContactMessage: submission.message || '',
                  ContactUrl: submission.url || window.location.href,
                  GorgiasContactFormUid: section.dataset.gorgiasContactFormUid || '',
                  GorgiasSource: section.dataset.gorgiasSource || ''
                }
              }
            }
          },
          custom_source: source
        },
        relationships: {
          list: {
            data: {
              type: 'list',
              id: listId
            }
          }
        }
      }
    }

    window
      .fetch(`${subscriptionUrl}?company_id=${publicKey}`, {
        method: 'POST',
        headers: {
          revision: KLAVIYO_REVISION,
          'content-type': 'application/json'
        },
        body: JSON.stringify(payload),
        keepalive: true
      })
      .catch(() => {})
  }

  window.addEventListener('message', (event) => {
    const section = getSectionFromMessageSource(event.source)

    if (!isGorgiasContactSubmit(event, section)) return

    const submission = getRequestBody(event.data.fetchOptions)
    if (!submission) return

    subscribeToKlaviyo(section, submission)
  })

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest(SELECTORS.liveChatTrigger)

    if (!trigger) return

    event.preventDefault()
    openLiveChat()
  })

  if (new URLSearchParams(window.location.search).has('chat')) {
    const tryOpen = () => {
      if (!window.GorgiasChat && typeof window.zE !== 'function') {
        return window.setTimeout(tryOpen, 500)
      }

      if (window.GorgiasChat) {
        window.GorgiasChat.init().then(() => openLiveChat())

        return
      }

      openLiveChat()
    }

    tryOpen()
  }
})()
